<h3-shape-list-and-tag-editor
  [isMultiFrame]="false"
></h3-shape-list-and-tag-editor>
